<template>
  <main id="main-content" class="home">
    <div v-html="content_text">{{ content_text }}</div>
    <Gallery v-if="gallery_images_ids" v-bind:images_ids="gallery_images_ids" />
  </main>
</template>

<style scoped>
.content {
  border: 1px solid blue;
}
</style>
<script>
import axios from "axios";
import Gallery from "@/components/Gallery.vue";

const GALLERY_API = window.APP_INFO.init.REST_PREFIX + "/wp-json/gallery/v1/";

export default {
  name: "Content",
  components: {
    Gallery,
  },
  data() {
    return {
      has_selectors_class: false,
      gallery_images_ids: null,
        trans: {
            click_to_open_gallery: window.APP_INFO.trans.click_to_open_gallery,
        },
    };
  },
  props: {
    content_text: {
      type: String,
      required: false,
    },
    content_title: {
      type: String,
      required: false,
    },
    template: {
      type: String,
      required: false,
    },
    services: {
      type: Array,
      required: false,
    },
  },
  /*computed:{
   services(){ return this.services;}
},*/

  watch: {
    services() {
      return this.services;
    },
  },
  updated() {
    console.log("Content.vue updated");

    this.bindFrashmail(document.getElementsByClassName("form_subscribe"));
    this.bindGalleries(document.querySelectorAll("[data-load-gallery]"));
    //console.log(this.content_text);
    // console.log(this.services);
    if (this.services != null && this.services.indexOf("freshmail") > -1) {
      //console.log("fm here youpiiii");
    }

    let tfm = TilesFilterManager({
      tilesContainerClass: "old-events",
      tileSelectorClass: "event",
      mode: "optimally",
    });
    tfm.init();
    //console.log(this.content_text);

    const pattern = /img src="([^"]+)"/g;
    let result;
    while ((result = pattern.exec(this.content_text))) {
      //console.log(result[1]);
      let $_img = document.createElement("img");

      $_img.addEventListener("load", function (e) {
        //console.log('loaded ' + $_img.src);
        tfm.resize();
      });

      $_img.src = result[1];
    }

    /*
    document.addEventListener("DOMContentLoaded",
            function() {
                console.log("DCL updated")
               // tfm.init()
            }
    );

    window.addEventListener("load",
           // tfm.resize
    );
*/
    window.addEventListener("resize", tfm.resize);
  },
  mounted() {
    console.log("Content.vue mounted");

    this.bindFrashmail(document.getElementsByClassName("form_subscribe"));
    this.bindLinks();
    this.bindShoplo(document.querySelectorAll('[data-shoplo="add-to-cart"]'));
    this.bindGalleries(document.querySelectorAll("[data-load-gallery]"));
    // const vm = this;
    // vm.showVideo(vm.content.page)
    let tfm = TilesFilterManager({
      tilesContainerClass: "old-events",
      tileSelectorClass: "event",
      mode: "optimally",
    });
    tfm.init();
    //console.log(this.content_text);

    const pattern = /img src="([^"]+)"/g;
    let result;
    while ((result = pattern.exec(this.content_text))) {
      //console.log(result[1]);
      let $_img = document.createElement("img");

      $_img.addEventListener("load", function (e) {
        // console.log('loaded ' + $_img.src);
        tfm.resize();
      });

      $_img.src = result[1];
    }

    window.addEventListener("resize", tfm.resize);
  },
  methods: {
    bindLinks() {
      let vm = this;

      let $links = document.querySelectorAll("#main-content a[data-page-type]");
      console.log($links);
      for (let i = 0; i < $links.length; i++) {
        $links[i].addEventListener("click", function (e) {
          e.preventDefault();
          console.log(e.currentTarget.dataset.pageType);
          console.log(e.currentTarget.href);
          console.log(e.currentTarget.dataset.pageId);
          vm.$emit("reload", {
            type: e.currentTarget.dataset.pageType,
            href: e.currentTarget.href,
            id: e.currentTarget.dataset.pageId,
          });
        });
      }
    },
    bindFrashmail(fm) {
      let vm = this;

      for (let i = 0; i < fm.length; i++) {
        fm[i].onsubmit = function (e) {
          console.log(e);
          let fm_form_id =
            ".freshmail_form_" +
            fm[i].querySelector("input[name=fm_form_id]").value;
          let $button = fm[i].querySelector("button.form_subscribe_button");
          let $message = fm[i].querySelector(".message");
          $message.innerHTML = "";

          let btn_val = $button.innerHTML;

          $button.innerHTML = window.APP_INFO.trans.sending;
          $button.disabled = true;

          //console.log(new FormData(fm[i].querySelector('form')))

          axios
            .post(
              window.APP_INFO.init.WP_AJAX,
              new URLSearchParams(new FormData(this)).toString()
            )
            .then(function (response) {
              console.log(response);

              console.log(response.data.status);

              $message.innerHTML = response.data.message;
              $button.innerHTML = btn_val;
              $button.disabled = false;
            })
            .catch(function (error) {
              console.log(error);
              $button.innerHTML = btn_val;
            });
          return false;
        };
      }
    },
    bindShoplo($links) {
      if ($links != null) {
        let i;
        let vm = this;
        for (i = 0; i < $links.length; i++) {
          $links[i].addEventListener("click", function (e) {
            //console.log(e.target);
            //console.log(e.target.getAttribute('data-product-variant_id'));
            vm.$emit("shoplo_add_product_cart", {
              variant_id: e.target.getAttribute("data-product-variant_id"),
              quantity: 1,
            });
          });
        }
      }
    },
    bindGalleries($links) {
      if ($links != null) {
        let i;
        let vm = this;
        for (i = 0; i < $links.length; i++) {
          $links[i].addEventListener("click", function (e) {
            e.preventDefault();

            let collection_id = e.currentTarget.getAttribute(
              "data-load-gallery"
            );
            axios
              .get(`${GALLERY_API}collections/` + collection_id)
              .then(function (response) {
                // console.log(response.data.images_ids)
                if (response.data.images_ids != null) {
                  vm.gallery_images_ids = response.data.images_ids;
                } else {
                  vm.gallery_images_ids = null;
                }
              });
            return false;
          });
        }
      }
    },
  },
};
</script>